<template>
  <div class="w-full text-NotoSansLight">
    <div class="lg:border-2 border-gray-500 py-6 px-2 lg:px-4 mb-6 lg:mb-12 rounded lg:py-8">
      <form class="w-full max-w-md mx-auto pb-4">
        <h3 class="mb-6 lg:mb-8 text-base lg:text-lg text-center border-b lg:border-b-0 pb-1">查詢訂戶編號</h3>
        <div class="md:flex md:items-center mb-4">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm mb-1 md:mb-0 pr-4" for="name">
              收件人姓名
            </label>
          </div>
          <div class="md:w-3/4">
            <input class="bg-white text-sm appearance-none border-2 border-gray-500 rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
            id="name" type="text" placeholder="雜誌收件人姓名" v-model.trim="name" maxlength="20">
          </div>
        </div>
        <div class="md:flex md:items-center mb-6 lg:mb-10">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm mb-1 md:mb-0 pr-4" for="inline-username">
              E-MAIL信箱
            </label>
          </div>
          <div class="md:w-3/4">
            <input class="bg-white text-sm appearance-none border-2 border-gray-500 rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
              id="email" type="email" placeholder="訂閱時填寫的e-mail" v-model.trim="email">
          </div>
        </div>
        <div class="w-full flex items-center mb-8 justify-center">
          <button class="button-red focus:outline-none text-white text-base py-2 px-12 rounded focus:shadow-none w-full md:w-auto"
          type="button" @click="submit">
            確認送出
          </button>
        </div>
      </form>
      <div class="w-full max-w-lg mx-auto">
        <div class="flex md:items-center pb-6 flex-wrap border-b md:border-b-0 text-NotoSansRegular">
          <label class="w-full block text-gray-800 text-sm text-center md:text-left mb-1">
            <span class="text-sm">
              ＊本功能僅提供「雜誌訂戶」查詢，請於訂單成立後三個工作天方可使用。
            </span>
          </label>
          <label class="w-full block text-gray-800 text-sm text-center md:text-left">
            <span class="text-sm">
              ＊若有任何問題請撥打客服專線：02-25787838
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="px-4 md:px-10 mb-4 md:mb-8 text-sm textColorDarkBlack text-NotoSansRegular">
      <h3 class="mb-2 md:mb-3 md:text-center font-bold">親愛的訂戶您好：</h3>
      <p class="leading-loose">若要在線上査詢您的「訂戶編號」，請輸入「雜誌收件人姓名及您訂閱時所留下的「E-Mail信箱」為了保障您的資料安全，若您輸入的E-Mail信箱非當初所留，或訂閱時沒有留下E-Mail信箱，及任何問題，您可透過讀者服務信箱，或致電LiveABC互動英語教學集團客服部（02）25787838，亦可査詢您的訂戶編號。</p>
    </div>
    <div class="sub flex px-2 md:px-10 flex-wrap mb-8 text-NotoSansRegular">
      <div class="w-full md:w-1/2 mb-4 md:mb-8">
        <img src="~@/assets/images/label.png" alt="Description" class="object-contain mx-auto">
      </div>
      <div class="w-full md:w-1/2 flex items-center px-12 md:px-8 text-sm text-center md:text-left">
        <p>您每周收到的雜誌封套名條上，即印有您的雜誌到期期數、訂戶編號</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Regex from '@/components/modules/regex'
import axios from 'axios'
import sweetAlert from '@/components/modules/sweetAlert'
export default {
  name: 'SubscriberNumbering',
  metaInfo () {
    return {
      title: '查詢訂戶編號',
      titleTemplate: null
    }
  },
  data () {
    return {
      name: null,
      email: null
    }
  },
  mixins: [
    Regex,
    sweetAlert
  ],
  components: {
  },
  computed: {
    ...mapGetters([
      'userRole',
      'user'
    ])
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    submit () {
      // 查詢訂戶編號
      let self = this
      if (self.email && self.name && self.rexEmail(self.email)) {
        self.$store.dispatch('isLoading', true)

        axios.post('/check-subscriber-id', {
          'cust_name': self.name,
          'email': self.email
        })
          .then((response) => {
            self.$store.dispatch('isLoading', false)
            if (response.data.status === true) {
              let alertMsg = '您的訂戶編號為: ' + response.data.cust_id
              self.alertPop('success', alertMsg)
              // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '您的訂戶編號為: ' + response.data.cust_id, type: 'check' })
            } else {
              self.alertPop('info', '查無訂戶資料')
              // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '查無訂戶資料', type: 'alert' })
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hide {
  opacity: 0;
}
</style>
